import React, { Component, Fragment } from "react";
import { Link, withRouter,Redirect } from "react-router-dom";
import ReactDOM from 'react-dom';
import Modal from 'react-responsive-modal';
import api from "../../services/api"
import Logo from "../../assets/img/logo4.jpg"



class Map extends Component {
  
    state = {
        open: true,
        unidades:[],
        idunidade:"",
        error:"",
        toreload:false
      };
     
      onOpenModal = () => {
        this.setState({ open: true });
      };
     
      onCloseModal = () => {
        if(this.state.idunidade=="0" || this.state.idunidade==null){
          this.setState({ 
            error:"Seleciona uma localidade"
          })
        }else{
          this.setState({ open: false,error:"" });
          
          if(this.state.toreload==true){
            window.location.reload();
          }
        }
        
       
      };
    
      async loadunidades(){
        const response1 = await api.post("/unidades");
        this.setState({ 
                unidades:response1.data
        })
      }

      componentWillMount(){
        this.loadunidades();

        if(localStorage.getItem('idunidade')){
          this.setState({ 
            idunidade:localStorage.getItem('idunidade')
          })
          this.onCloseModal();

        }
      }

      
      shouldComponentUpdate(nextProps, nextState){
        if(nextState.idunidade!== this.state.idunidade){
          localStorage.setItem('idunidade', nextState.idunidade);
          nextState.toreload=true;
          

        }
        return true;

      }


render() {

    const { open } = this.state;


return (
    <React.Fragment>

<i class="fas fa-city"></i><a onClick={e => this.setState({ open: true })}> Trocar Unidade</a>
<div class="sizemodal">
        <Modal  open={open} onClose={this.onCloseModal} center>
       <div class="row text-center">
         
          <div class="col-sm-10">
          <img class="containermodal sizemodalimg text-center" src={Logo} alt="logo" />
          </div>        
        </div>
          <div class="row">
          <div class="col-lg">
          
              
              <select class="text-center custom-select" onChange={e => this.setState({ idunidade: e.target.value })}>
                  <option value="0">Escolha uma unidade</option>
                  {this.state.unidades.map(el => (
                    <option value={el.id} selected={this.state.idunidade==el.id}>
                      {el.nome}

                    </option>
                    

                    ))}	
              </select>
<center class="text-danger">{this.state.error}</center>




          </div>

        </div>
       


          <center><a class="btn btn-danger text-white" onClick={this.onCloseModal}>Acessar Site</a></center>





         

        </Modal>
   
        </div>
    </React.Fragment>
)



}

}

export default withRouter(Map);


// WEBPACK FOOTER //
// ./src/pages/content/modal.js